import CardTable from 'components/CardTable/CardTable'
import { useOpenComponent } from 'hooks/useOpenComponent'
import React, { useEffect, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AddIcon from "@mui/icons-material/Add";
import { columns } from './columns'
import {
  resetWarehouseSelected,
  addWarehouseMode,
  getWarehouses,
  getCRE_Licenses,
  setWarehousesCatalogFilters
} from 'redux/actions/warehousesCatalog/warehousesCatalogActions'
import RegularButton from 'components/CustomButtons/Button'
import Home from '@mui/icons-material/Home'
import { useSearch } from 'hooks/useSearch'
import { ModalV2 } from 'components/Modal/ModalV2'
import { FormWarehouseEdit } from './FormWarehouseEdit'
import { TableInputs } from "components/CardTable/TableInputs";
import { LOADING_ACTIONS } from 'redux/reducers/warehousesCatalog/warehousesTypes';

const tableKey = 'warehousesPage'

export const WarehousesCatalog = () => {
  // custom hook
  const { clearSearch, buildCompLoadings, buildTableConfig } = useSearch();
  const { token } = useSelector(state => state.login)
  const { stations } = useSelector((state) => state.companies)
  const { isLoadingComp, configTables } = useSelector((state) => state.search)
  const { warehousesArr, addWarehouse, station, addMode } = useSelector(state => state.warehousesCatalog)
  const { isOpen, handleIsOpen } = useOpenComponent()
  const dispatch = useDispatch()

  const handleClose = useCallback(() => {
    dispatch(resetWarehouseSelected())
    handleIsOpen()
  }, [dispatch, handleIsOpen])

  const handleOpenAdd = useCallback(() => {
    dispatch(addWarehouseMode())
    handleIsOpen()
  }, [dispatch, handleIsOpen])

  useEffect(() => {
    clearSearch()
    dispatch(getCRE_Licenses(token))
    dispatch(getWarehouses(token))
  }, [clearSearch, dispatch, token])

  const mapData = useMemo(() => {
    if (station?.id) {
      return warehousesArr?.filter(wh => wh.idStation === station.id).map(wh => ({
        ...wh,
        station: stations[wh.idStation]?.name,
        modal: handleIsOpen,
      })) || []
    }
    return warehousesArr?.map(tank => ({
      ...tank,
      station: stations[tank.idStation]?.name,
      modal: handleIsOpen,
    })) || []
  }, [warehousesArr, stations, station, handleIsOpen])

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey)
    buildCompLoadings(["loadingWarehouses", LOADING_ACTIONS.DELETE]);
  }, []);

  return (
    <React.Fragment>
      <CardTable
        data={mapData}
        columns={columns}
        title={"Catalogo de Almacenes"}
        icon={<Home />}
        hasHeader
        isLoading={isLoadingComp?.loadingWarehouses}
        blockBtn
        tableKey={tableKey}
        hasControl
        controls={
          addWarehouse && (
            <RegularButton round justIcon color="info" style={{ margin: 10 }} onClick={handleOpenAdd}>
              <AddIcon style={{ margin: 0 }} />
            </RegularButton>
          )
        }
        tableContent={
          <TableInputs
            reducer="warehousesCatalog"
            stations
            dispatchAction={setWarehousesCatalogFilters}
            blockBtn
            submitButtonShow={false}
          />
        }
      />
      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
        title={ addMode ? 'Agregar nuevo almacén': 'Modificar almacén'}
      >
          <FormWarehouseEdit handleClose={handleClose} />
      </ModalV2>
    </React.Fragment>
  )
}
